import { Eyebrow, FadeIn } from "./Reveal";

export default function VideoSection() {
  return (
    <section className="bg-navy-950 py-24 lg:py-32" data-testid="video-section">
      <div className="mx-auto max-w-6xl px-5 text-center sm:px-8">
        <Eyebrow center>Clew Bay &amp; North Mayo</Eyebrow>
        <FadeIn delay={0.1}>
          <h2 className="mx-auto mt-6 max-w-3xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
            What Clew Bay &amp; North Mayo <em className="italic text-gold">has to offer</em>
          </h2>
        </FadeIn>
        <FadeIn delay={0.2}>
          <div className="mt-14 flex justify-center">
            <div className="overflow-hidden border border-gold/25 bg-navy-900">
              <video
                src="/videos/clew-bay-720.mp4"
                poster="/videos/clew-bay-poster.jpg"
                preload="metadata"
                autoPlay
                muted
                loop
                playsInline
                data-testid="clew-bay-video"
                className="block h-[70vh] max-h-[720px] w-auto max-w-full"
              />
            </div>
          </div>
          <p className="mt-6 text-[12px] uppercase tracking-[0.2em] text-mist">
            Filmed on the bay &mdash; islands, wildlife and the Wild Atlantic Way
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
